import { Component, Input } from '@angular/core';
import { IconModule } from '../icon/icon.module';
import { ButtonComponent } from '../button/button.component';
import { ToastService } from 'src/services/toast.service';
import { GlobalService } from 'src/services/global.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-header',
  templateUrl: './header-default.component.html',
  standalone: true,
  imports: [IconModule, ButtonComponent],
})
export class HeaderComponent {
  @Input()
  styleClass: string = '';

  @Input()
  containerStyleClass: string = '';

  @Input()
  backTitle: string = 'Kembali';

  @Input()
  backTitleStyleClass: string = '';

  constructor(
    protected location: Location,
    protected toastService: ToastService,
protected globalService: GlobalService,
  ) {}
}
